require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es7.symbol.async-iterator.js
// module id = Q1to
// module chunks = 10